module.exports = __webpack_public_path__ + "img/11.7ec43b11.png";